// @flow
import * as React from 'react';
import { injectGlobal } from 'styled-components';
import baseCSS from './base-css';
import normalizeCSS from './normalize';

type Props = { children: React.Element<*> };

class ResetCSS extends React.Component<Props, *> {
    componentWillMount() {
        injectGlobal`${normalizeCSS}`;
        injectGlobal`${baseCSS}`;
    }

    render() {
        return this.props.children;
    }
}

export default ResetCSS;



// WEBPACK FOOTER //
// ./src/components/reset-css/index.js